<div class="sidebar-padded-page-content">
	<div class="copo-notification">
		<div class="copo-cell-notification">
			<mat-icon svgIcon="alert" [attr.title]="'offline.alert' | translate"></mat-icon>
		</div>
		<div class="copo-cell-notification-padding" translate>user.no.connection</div>
	</div>
</div>
